import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=cb3874b2&scoped=true&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=cb3874b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3874b2",
  null
  
)

export default component.exports